module.exports = {"id":"dp4_2l3q4","text":"Protecting personal data and privacy","instructions":"Which situation qualifies as a personal data breach?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.2","questionType":"PickOne","random":true,"options":[{"id":"dp4_2l3q4-a1","text":"Unauthorised access to records","score":3.7},{"id":"dp4_2l3q4-a2","text":"Routine data backup process","score":1.3},{"id":"dp4_2l3q4-a3","text":"System performance update","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.2/l3q4.json
// module id = 1231
// module chunks = 41